import React from 'react';
import { Section } from 'jbc-front/components/Form';
import { getOptionLabel, display } from 'src/utils/Utils';
import DefaultValue from './DefaultValue';
import tableStyles from '../styles/GeneralTableInfo.scss';
import { useTranslation } from 'react-i18next';

const BankItem = ({ bankItem, index, depositTypes }) => {
  const { t } = useTranslation();
  return (
    <div>
      <Section title={t('features.Employees.components.BankItemSection.bank_account_information')+` ${index + 1}`}>
        <table className={tableStyles.mTablePersonal}>
          <tbody>
            {bankItem.isUseToTransfer && (
              <tr>
                <th>{t('features.Clients.components.BanksSectionShow.use_as_transfer_account')}</th>
                <td />
              </tr>
            )}
            <tr>
              <th>{t('features.Clients.components.BanksSectionShow.Bank')}：</th>
              <td>{display(bankItem.bankName)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.BankItemSection.bank_code')}：</th>
              <td>{display(bankItem.bankCode)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.BankItemSection.bank_short_name')}：</th>
              <td>{display(bankItem.bankShortName)}</td>
            </tr>
            <tr>
              <th>{t('features.Clients.components.BanksSectionShow.Branch')}：</th>
              <td>{display(bankItem.branchName)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.BankItemSection.branch_code')}：</th>
              <td>{display(bankItem.branchCode)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.BankItemSection.account_type')}：</th>
              <td>{display(getOptionLabel(bankItem.depositType)(depositTypes))}</td>
            </tr>
            <tr>
              <th>{t('features.EmployeeBonus.ShowBonusFbDataPage.bank_account_number')}：</th>
              <td>{display(bankItem.accountNumber)}</td>
            </tr>
            <tr>
              <th>{t('features.Employees.components.BankItemSection.account_holder_name')}：</th>
              <td>{display(bankItem.accountHolder)}</td>
            </tr>
          </tbody>
        </table>
      </Section>
    </div>
  )
};

const BanksSectionShow = ({ employeeBanks, depositTypes }) => {
  if (employeeBanks && employeeBanks.length > 0)
    return (
      <div>
        {employeeBanks.map((item, index) => (
          <BankItem bankItem={item} key={item.id} index={index} depositTypes={depositTypes} />
        ))}
      </div>
    );
  return <DefaultValue />;
};

export default BanksSectionShow;
